import { BaseComponent } from '../../components/base-component'
import type { AccordeonComponent } from '../../components/accordeon/accordeon'
import { $list, whenDefined } from 'src/scripts/utils/utils'

const ACCORDEON_SELECTOR = 'accordeon-component'

export class FaqSection extends BaseComponent {
  mountComponent(): void {
    const tabs: AccordeonComponent[] = $list(ACCORDEON_SELECTOR, this)
    tabs.forEach(tab => {
      whenDefined(ACCORDEON_SELECTOR).then(() => {
        tab.on('toggle', this.handleTabToggle)
      })
    })
  }

  unmountComponent(): void {
    const tabs: AccordeonComponent[] = $list(ACCORDEON_SELECTOR, this)
    tabs.forEach(tab => {
      whenDefined(ACCORDEON_SELECTOR).then(() => {
        tab.off('toggle', this.handleTabToggle)
      })
    })
  }

  handleTabToggle = ({ blockId }: { blockId: string }): void => {
    const tabs: AccordeonComponent[] = $list(ACCORDEON_SELECTOR, this)
    tabs.forEach(tab => {
      if (tab.dataset.blockId !== blockId && tab.isExpanded) {
        tab.hide()
      }
    })
  }
}
